// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1Snvk","box":"WorkspacesBox_box__gKgRj","node":"WorkspacesBox_node__fii_H"};